var theme = {
    hover: {
        opacityLow: 0.48,
        opacity: 0.64,
        opacityHigher: 0.84,
    },
    border: {
        radiusBig: "12px",
        radius: "8px",
        radiusSmall: "4px",
        width: "1px",
        style: "solid",
    },
    header: {
        height: 80,
    },
    footer: {
        desktop: {
            height: 52,
        },
        mobile: {
            height: 104,
            heightWithPosition: 104 + 56,
        },
    },
    governance: {
        actionBar: {
            height: 80,
        },
        footer: {
            mobile: {
                height: 164,
            },
        },
    },
};
export default theme;
//# sourceMappingURL=theme.js.map